import { DashboardDialogSelectOption } from './DashboardDialogSelectOption';

export class DashboardDialogSubcategoryOption extends DashboardDialogSelectOption {
  constructor(public subcategory: string, public index: number) {
    super(`${subcategory}_${index}`, subcategory);
  }
}
